import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import FollowingWatchIcon from '../FollowingWatch';
import CircleWrap from '../../CircleWrap';
import s from './EyeDisc2.scss';
var EyeDisc2 = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(CircleWrap, { circleClassName: classnames(s['disc'], className), size: props.size },
        React.createElement(FollowingWatchIcon, __assign({}, props, { disableDefaultColors: true }))));
};
EyeDisc2.displayName = 'EyeDisc2';
export default EyeDisc2;
//# sourceMappingURL=EyeDisc2.js.map